import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", id: "about" },
  { label: "Doctors", id: "consultants" },
  { label: "Services", id: "services" },
  { label: "Timings", id: "timings" },
  { label: "Contact", id: "contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-white/85 border-b border-border shadow-[0_8px_30px_rgb(0,0,0,0.04)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="Shah Eye Care Centre" className="h-11 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-[var(--ink-soft)] hover:text-[var(--teal)] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[var(--teal)] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
          <button
            data-testid="header-book-btn"
            onClick={() => go("booking")}
            className="px-5 py-2.5 rounded-full bg-[var(--teal)] text-white text-sm font-semibold hover:bg-[var(--teal-dark)] transition-colors shadow-[0_10px_25px_rgb(13,122,122,0.25)]"
          >
            Book Appointment
          </button>
        </nav>

        <button data-testid="mobile-menu-btn" className="md:hidden text-[var(--teal-dark)]" onClick={() => setOpen((o) => !o)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden backdrop-blur-xl bg-white/95 border-b border-border"
          >
            <div className="px-6 py-5 flex flex-col gap-4">
              {links.map((l) => (
                <button key={l.id} data-testid={`mobile-nav-${l.id}`} onClick={() => go(l.id)} className="text-left text-base font-medium text-[var(--ink)]">
                  {l.label}
                </button>
              ))}
              <button data-testid="mobile-book-btn" onClick={() => go("booking")} className="mt-2 px-5 py-3 rounded-full bg-[var(--teal)] text-white text-sm font-semibold">
                Book Appointment
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
